// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_d88be3', '__Inter_Fallback_d88be3'","fontStyle":"normal"},"className":"__className_d88be3"};